import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { useMediaQuery } from '../../../../hooks/mediaQuery';
import {
  CarouselImage,
  TourCardType
} from '../../../../types/pages/landing-page';
import { getDurationHoursFromMinutes } from '../../../../utils/getCurrentDayOpeningHours';

interface BlogRelatedTourCardProps {
  product: TourCardType;
}

export default function BlogRelatedTourCard({
  product
}: BlogRelatedTourCardProps) {
  const isMobileScreen = useMediaQuery(639);

  return product?.carousel && product?.carousel?.length > 0 ? (
    <Link target="_blank" href={`/tours/${product.slug}`} className="w-full">
      <div className="border border-[#E0E0E0] rounded-lg flex-shrink-0 bg-white">
        <div className="flex xl:flex-row xl:gap-[22px] 2xl:gap-[26px]">
          <Image
            src={(product.carousel?.[0] as CarouselImage)?.image}
            alt={(product.carousel?.[0] as CarouselImage)?.alt}
            width={210}
            height={190}
            className="object-cover w-[118px] h-[123px] sm:w-[160px] sm:h-[160px] lg:w-[140px] lg:h-[160px] xl:w-[170px] xl:h-[168px] 2xl:w-[170px] 2xl:h-[160px] 3xl:h-[165px] rounded-tl-[7px] rounded-bl-[7px]"
          />

          <div className="py-2.5 sm:py-2 2xl:pb-1.5 2xl:pt-2 3xl:pb-2 3xl:pt-3 px-4 xl:py-3 xl:pr-[15px] xl:px-0 xl:w-[60%] flex flex-col space-y-3 h-full">
            <h3
              className="text-black13 text-sm sm:text-[17px] font-semibold overflow-hidden"
              style={{
                display: '-webkit-box',
                WebkitLineClamp: isMobileScreen ? 2 : 1,
                WebkitBoxOrient: 'vertical'
              }}
            >
              {product.name}
            </h3>

            <div className="flex flex-row items-center">
              <div className="flex gap-1.5 items-center">
                <Image
                  src={'/gray-clock-icon.svg'}
                  alt="calender-icon"
                  width={12}
                  height={12}
                />
                <p className="text-[13px] sm:text-sm text-gray75 whitespace-nowrap">
                  {getDurationHoursFromMinutes(product?.duration)}
                </p>
              </div>
            </div>
            {!isMobileScreen && (
              <p
                className="leading-normal text-sm text-gray75 overflow-hidden h-[40px]"
                style={{
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical'
                }}
              >
                {product.snippet}
              </p>
            )}

            <div className="flex gap-1.5 items-center">
              <span className="text-[#666666] text-sm 2xl:text-[15px] font-light capitalize">
                From
              </span>
              <span className="text-[#222222] text-sm sm:text-xl 2xl:text-xl 3xl:text-xl font-semibold">
                ${product.price}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  ) : null;
}
